"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  circleDeterminate: {
    strokeLinecap: 'round'
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiCircularProgress.js.map